/** 用户选中的 TTS 音色，存 localStorage；id 对应 GET /v1/tts/voices 的 id。 */

const VOICE_KEY = "idea_tts_voice";
const VOICE_NAME_KEY = "idea_tts_voice_name";

export type TtsVoice = {
  id: string;
  name: string;
  desc: string;
};

export function getSelectedVoiceId(): string | null {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage.getItem(VOICE_KEY);
  } catch {
    return null;
  }
}

export function getSelectedVoiceName(): string | null {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage.getItem(VOICE_NAME_KEY);
  } catch {
    return null;
  }
}

export function setSelectedVoice(voice: TtsVoice) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(VOICE_KEY, voice.id);
    window.localStorage.setItem(VOICE_NAME_KEY, voice.name);
  } catch {
    // quota / private mode —— 不挡主流程
  }
}

/** 设置页试听用的固定示例句。
 *  不带产品名：试听是听音色，不是听自我介绍；改名字也不用回来改代码。 */
export const TTS_PREVIEW_TEXT = "你好，很高兴为你服务。";
